import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";

import { Document, Page } from 'react-pdf';

import { useState } from 'react';

import Resume from "../pdf/Frederic_Desjardins_Resume_2025.pdf"

import {
  dataabout,
  meta,
  skills,
} from "../../content_option";


export const About = () => {

  console.log(Resume); // check that this is the correct value

  const [numPages, setNumPages] = useState(null);

  const [pageNumber, setPageNumber] = useState(1); //setting 1 to show fisrt page

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  function FixItLink({ myString }) {
    if (typeof myString === "undefined") {
      return null; // or you can return a different component or message
    } else {
      return <a href={myString}>
        <div id="button_p" className="ac_btn btn ">
          The FixIt App
        </div>
      </a>

    }


  }
  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title> About | {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3">
          <Col lg="12">
            <h1 className="display-4 mb-4">About me</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="5">
            <h3 className="color_sec py-4">{dataabout.title}</h3>
          </Col>
          <Col lg="7" className="d-flex align-items-center">
            <div>
              <p>{dataabout.aboutme}</p>
            </div>
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lang="7">
            <h3 className="color_sec py-4">Skills</h3>
          </Col>
          <Col lg="7">
            {skills.map((data, i) => {
              return (
                <div className="service_ py-4" key={i}>
                  <h5 className="service__title">{data.title}</h5>
                  <p className="service_desc">{data.description}</p>
                  <FixItLink myString={data.link} ></FixItLink>
                </div>
              );
            })}
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="5">
            <h3 className="color_sec py-4">Resume</h3>
          </Col>

          <div className="pdf-wrap">
            <div className="pdf-view">
              <div className="pdf-container">
                <Document
                  file={Resume}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  <Page pageNumber={pageNumber} renderTextLayer={false} />
                </Document>
              </div>
            </div>
            <div>
              <p>
                Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
              </p>
              <button type="button" className="ac_btn btn " disabled={pageNumber <= 1} onClick={previousPage}>
                Prev
              </button>
              <button
                type="button"
                className="ac_btn btn "
                disabled={pageNumber >= numPages}
                onClick={nextPage}
              >
                Next
              </button>
              <a href={Resume} download="Frederic_Resume.pdf"> Download </a>
            </div>
            <br></br>

          </div>
        </Row>
      </Container>
    </HelmetProvider >
  );
};